/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { Provider } from 'react-redux';

import Clarity from '@microsoft/clarity';

import HostRouter from './components/HostRouter';
import MfeToolkit from './components/mfeToolkit/MfeToolkit';
import { context, store } from './store';

// Application Insights bootstrap
const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
  },
});
appInsights.loadAppInsights();
appInsights.trackPageView();

// Clarity bootstrap
if (process.env.REACT_APP_CLARITY_PROJECT_ID && process.env.REACT_APP_CLARITY_PROJECT_ID?.toString?.() !== 'false') {
  Clarity.init(process.env.REACT_APP_CLARITY_PROJECT_ID);
}

function App() {
  return (
    <Provider store={store} context={context}>
      <HostRouter />
      <MfeToolkit />
    </Provider>
  );
}

export default App;
